import popupsState from "../popups/popups-state";

// Показывает попапы, которые вернул сервер (?).

const $ = window.jQuery;

$(() => {
    const popupErrorMessages = [];
    const popupSuccessMessages = [];
    let popupSuccessDetails = [];
    let text = null;
    let details = null;
    $(".popup-message")
        .each((i, e) => {
            text = $(".message", $(e))
                .text()
                .replace(/(?:\r\n|\r|\n)/g, "<br />");
            details = $(".details span")
                .map((i, el) => $(el)
                    .html())
                .get();
            if ($(e)
                .hasClass("success")) {
                popupSuccessMessages.push(text);
                popupSuccessDetails = details;
            } else {
                popupErrorMessages.push(text);
            }
        });
    if (popupErrorMessages.length) {
        popupsState.dispatchOpen({
            newPopupId: "error_popup",
            popupData: { errors: popupErrorMessages },
        });
    }

    if (popupSuccessMessages.length) {
        popupsState.dispatchOpen({
            newPopupId: "message_popup",
            popupData: {
                message: popupSuccessMessages,
                messageDetails: popupSuccessDetails,
            },
        });
    }
}); // end of dom ready

export default {};
